export enum ReferenceNumberRedeliveryTransactionType {
  Purchase = 'purchase',
  Pickup = 'pickup',
  Transfer = 'transfer',
  RentalSwapReturn = 'rental_swap_return',
  SaleSwapReturn = 'sale_swap_return',
  Recycle = 'recycle',
  Rejection = 'rejection',
}
